import React, {useEffect} from "react";
import {useCommonStyles} from "./utils/commonStyles";

export default function Home() {
    const classes= useCommonStyles();
    useEffect( ()=>{
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();

        var s1=document.createElement("script");
        s1.async=true;
        s1.src='https://embed.tawk.to/613135c6d6e7610a49b35e37/1fek3k53a';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s1.id='tawk_script';
        // s0.parentNode.insertBefore(s1,s0);
        document.body.appendChild(s1);
        // return ()=> {
        //     document.body.removeChild(s1);
        // }
    },[]);
    return (
        <div>

            <div style={{textAlign: "center"}} className={classes.layout}>
                <h3 className="header-sub-title wow fadeInUp" data-wow-duration="1.3s"
                    data-wow-delay="0.2s">Bienvenido a</h3>
                <img className="wow fadeInLeftBig" data-wow-duration="1s"
                     data-wow-delay="0.5s" src="assets/img/Purple.png" alt="brand"/>
                <h2 className="header-title wow fadeInUp" data-wow-duration="1.3s"
                    data-wow-delay="0.5s">Inicia sesion para continuar</h2>
                <br/>
            </div>
        </div>
    )
}